// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZsRK","toggle":"styles_toggle__P80d4","preview":"styles_preview__JkCbl"};